function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from "prop-types";
import cn from "../../../utils/cn";
import filterChildren from "../../utils/Children/filterChildren";
import "./Table.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const Table = _ref => {
  let {
    id = "",
    className = "",
    onCellClick = null,
    noBorder = false,
    responsiveCardStyle = false,
    secondaryDataList = [],
    style = {},
    children = []
  } = _ref;
  /**
   * on cell click will return rowIndex and columnIndex
   * @param {number} row
   * @param {number} column
   * @public
   */
  const handleCellClick = (row, column, event) => {
    if (onCellClick) {
      onCellClick(row, column, event);
    }
  };
  const tableClass = cn({
    "rounded overflow-auto w-full app-components-table border border-solid border-light-border-blue": true,
    "border-none": noBorder,
    "app-components-table--responsive-cards": responsiveCardStyle
  }, className);
  const newChildren = filterChildren(children, _objectSpread(_objectSpread({}, onCellClick ? {
    onCellClick: handleCellClick
  } : null), {}, {
    parent: "table",
    secondaryDataList
  }));
  return /*#__PURE__*/_jsx("div", {
    id: id,
    className: tableClass,
    style: style,
    children: /*#__PURE__*/_jsx("table", {
      className: "border-collapse font-regular-font w-full",
      children: newChildren
    })
  });
};
Table.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /**
   * Called when a row cell is clicked.  Returns a row number
   */
  onCellClick: PropTypes.func,
  /** Bool to remove the border around the Table */
  noBorder: PropTypes.bool,
  /** Bool to display the table rows as cards on small screens */
  responsiveCardStyle: PropTypes.bool,
  /** Data (in columns) to hide passed from TableRow component */
  secondaryDataList: PropTypes.array,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /**
   * children props for content inside
   * @ignore
   */
  children: PropTypes.node
};
export default Table;
//# sourceMappingURL=Table.js.map